import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Button,
  Heading,
  Text,
  useToast,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import {
  dark,
  white,
  textPrimary,
  textSecondary,
  primary,
  newBorder,
} from "../../../../utils/colors";
import { useTranslation } from "react-i18next";
import VerificationInputs from "../../../../components/input/VerificationInputs";
import { useDispatch, useSelector } from "react-redux";
import {
  verifyTenantEmailByCodeAction,
  resendVerificationEmailAction,
} from "../../../../actions/tenantRegisterActions";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaArrowRightLong } from "react-icons/fa6";
import { motion } from "framer-motion";
// import {
//   TENANTREGISTER_REGISTER_RESET,
//   TENANTREGISTER_RESEND_VERIFICATION_EMAIL_RESET,
//   TENANTREGISTER_VERIFY_EMAIL_BYCODE_RESET,
// } from "../../../../constants/tenantRegisterConstants";
dayjs.extend(duration);

const RegisterVerification = ({
  language,
  registrationEmail,
  verificationCode,
  setVerificationCode,
  setCurrentStep,
  countdown,
  setCountdown,
  handleBack,
  loadingVerify,
}) => {
  // TRANSLATION
  const { t } = useTranslation();
  const toast = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // STATE
  const [isResent, setIsResent] = useState(false);

  // REDUX

  const tenantRegisterResendVerificationEmail = useSelector(
    (state) => state.tenantRegisterResendVerificationEmail
  );
  const {
    loading: loadingResend,
    error: errorResend,
    success: successResend,
  } = tenantRegisterResendVerificationEmail;

  // HANDLERS
  const verifyTenantByCode = () => {
    dispatch(
      verifyTenantEmailByCodeAction(
        registrationEmail,
        verificationCode,
        language
      )
    );
  };

  const resendVerificationEmail = () => {
    dispatch(resendVerificationEmailAction(registrationEmail, language));
  };

  // USE EFFECTs
  useEffect(() => {
    if (successResend) {
      toast({
        title: t("toasts.resendVerificationEmailSuccess"),
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setIsResent(true);
      setCountdown(dayjs.duration(600, "seconds")); // RESET COUNTDOWN TO 10 MINUTES
    }
  }, [successResend]);

  useEffect(() => {
    if (errorResend) {
      toast({
        title: t("toasts.resendVerificationEmailError"),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [errorResend]);

  // LOG
  // console.log("countdown", countdown);

  // console.log("verificationCode", verificationCode);
  // console.log("token", token);

  return (
    <>
      <Box
        position="absolute"
        top="2rem"
        left={`calc(29% + 2rem)`}
        zIndex={10000}
      >
        <IconButton
          border={`1px solid ${newBorder}`}
          size="md"
          borderRadius="100rem"
          bg={white}
          fontSize="20px"
          icon={<Icon h="0.875rem" as={FaArrowLeft} />}
          onClick={handleBack}
        />
      </Box>

      <Box
        as={motion.div}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        mt={12}
      >
        <form onSubmit={verifyTenantByCode}>
          <Box w="100%" mb={12}>
            <Heading
              fontSize="1.875rem"
              fontWeight="700"
              color={textPrimary}
              mb={3}
            >
              {t("common.enterVerificationCode")}
            </Heading>
            <Text color={textSecondary} fontWeight="500" w="100%" fontSize="sm">
              {t("common.verificationCodeSent")}{" "}
              <Text as="span" fontWeight="500" color={textPrimary}>
                {registrationEmail}
              </Text>
            </Text>
          </Box>

          <VerificationInputs length={6} onComplete={setVerificationCode} />

          <Button
            type="submit"
            onClick={verifyTenantByCode}
            isLoading={loadingVerify}
            h="3.5rem"
            borderRadius="10rem"
            bg={dark}
            color={white}
            border={`1px solid ${dark}`}
            textAlign="center"
            w="100%"
            _hover={{
              bg: "rgba(13, 12, 34, 0.8)",
              color: white,
              border: `rgba(13, 12, 34, 0.8)`,
            }}
          >
            {t("common.verify")}
          </Button>

          <Text
            textAlign="center"
            fontSize="xs"
            fontWeight="500"
            color={textSecondary}
            m="1.5rem 0 0.25rem"
          >
            {countdown.format("mm:ss")}
          </Text>

          {!isResent ? (
            <Flex direction="column" w="100%">
              <Flex align="center" justify="center">
                <Text
                  fontSize="sm"
                  color={textSecondary}
                  fontWeight="500"
                  textAlign="center"
                >
                  {t("common.verificationNotReceived")}
                </Text>
                <Button
                  ml={1}
                  variant="link"
                  color={primary}
                  p={0}
                  size="sm"
                  role="group"
                  onClick={resendVerificationEmail}
                  _hover={{
                    transition: "0.2s all",
                  }}
                >
                  <Text
                    as="span"
                    color={primary}
                    _groupHover={{
                      pr: "0.25rem",
                      transition: "0.2s all",
                    }}
                  >
                    {t("common.resendCode")}
                  </Text>{" "}
                  <Icon ml={1} h="0.6rem" as={FaArrowRightLong} />
                </Button>
              </Flex>
            </Flex>
          ) : (
            <Flex direction="column" w="100%">
              <Text
                fontSize="sm"
                color={textSecondary}
                fontWeight="500"
                textAlign="center"
              >
                {" "}
                {t("common.verificationCodeResent")}
              </Text>
            </Flex>
          )}
        </form>
      </Box>
    </>
  );
};

export default RegisterVerification;
